import React from 'react';
import styled from 'styled-components';
import Card from 'components/Card';
import Select from 'components/Select/SelectFilter';
import { usePerformance } from '../context';
import { MARKETS, BRANDS, TIME_PERIODS } from '../fakeData';

const FiltersContainer = styled.div`
  > div {
    display: flex;
    flex-direction: column;
  }

  .distributionFiltersContainer {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 25px;
    width: 100%;
    align-items: flex-start;

    .label {
      margin-bottom: 15px;
    }

    @media (max-width: 1000px) {
      grid-template-columns: 1fr 1fr;
    }

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }

  .viewToggle {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-top: 10px;
  }
`;

const ToggleButton = styled.button<{ $active: boolean }>`
  font-family: ${(props) => props.theme.fonts.oswald};
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 6px 16px;
  border: 1px solid ${(props) => (props.$active ? '#e25d34' : '#d0d0d0')};
  background: ${(props) => (props.$active ? '#e25d34' : 'white')};
  color: ${(props) => (props.$active ? 'white' : '#2b3d54')};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    border-color: #e25d34;
  }
`;

const PerformanceFilters = () => {
  const { state, setFilters } = usePerformance();
  const { filters, lists } = state;

  const listOptions = [
    { value: '', label: 'All Restaurants' },
    ...lists.map((l) => ({
      value: l.id,
      label: `${l.name} (${l.store_ids.length})`
    }))
  ];

  const selectedListOption = filters.activeListId
    ? listOptions.find((o) => o.value === filters.activeListId) ||
      listOptions[0]
    : listOptions[0];

  return (
    <FiltersContainer>
      <Card>
        <div className="distributionFiltersContainer">
          <Select
            label="Market"
            placeholder="Select market..."
            options={MARKETS}
            selectedOption={filters.market}
            onChange={(val: (typeof MARKETS)[0] | null) =>
              setFilters({ market: val })
            }
          />
          <Select
            label="Brand"
            placeholder="Select brand..."
            options={BRANDS}
            selectedOption={filters.brand}
            onChange={(val: (typeof BRANDS)[0] | null) =>
              setFilters({ brand: val })
            }
          />
          <Select
            label="Time Period"
            placeholder="Select period..."
            options={TIME_PERIODS}
            selectedOption={filters.timePeriod}
            onChange={(val: (typeof TIME_PERIODS)[0] | null) =>
              setFilters({ timePeriod: val })
            }
          />
          <Select
            label="My Lists"
            placeholder="All restaurants"
            options={listOptions}
            selectedOption={selectedListOption}
            onChange={(val: (typeof listOptions)[0] | null) =>
              setFilters({ activeListId: val && val.value ? val.value : null })
            }
          />
          <div>
            <div
              className="label"
              style={{
                fontSize: 12,
                fontFamily: 'Oswald, sans-serif',
                textTransform: 'uppercase',
                color: '#153749',
                marginBottom: 7
              }}
            >
              View Mode
            </div>
            <div className="viewToggle">
              <ToggleButton
                $active={filters.viewMode === 'competitor'}
                onClick={() => setFilters({ viewMode: 'competitor' })}
              >
                Competitor
              </ToggleButton>
              <ToggleButton
                $active={filters.viewMode === 'panel'}
                onClick={() => setFilters({ viewMode: 'panel' })}
              >
                Panel
              </ToggleButton>
            </div>
          </div>
        </div>
      </Card>
    </FiltersContainer>
  );
};

export default PerformanceFilters;
